import React from "react";

const EmptyStateSuggestions = ({ assistant, onSelect }) => {
  if (!assistant) return null;

  const suggestions = {
    pmfast: ["¿Cuál es la mejor forma de estudiar?", "Hazme una pregunta tipo examen PMP"],
    crisis: ["Simula una situación de incidente crítico", "¿Qué hago si hay caída total de red?"],
    decision360: ["Dame opciones estratégicas", "¿Qué modelo aplico ante esta duda?"]
  };

  return (
    <div className="px-6 pt-4 text-sm text-gray-600">
      <p className="mb-2 font-semibold">¿No sabes por dónde empezar?</p>
      <ul className="space-y-2">
        {(suggestions[assistant] || []).map((text, idx) => (
          <li key={idx}>
            <button
              onClick={() => onSelect(text)}
              className="text-blue-600 hover:underline"
            >
              {text}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default EmptyStateSuggestions;
